export default __webpack_public_path__ + "static/media/BM.e1061059.png";